// Shared date-math helpers for the Studio Planner (Gantt) — pure functions,
// no timezone gymnastics needed since we only ever deal in whole days.

export function parseYMD(s) {
  if (!s) return null;
  const d = new Date(`${String(s).slice(0, 10)}T00:00:00`);
  return isNaN(d) ? null : d;
}

export function fmtYMD(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function addDays(d, n) {
  const out = new Date(d);
  out.setDate(out.getDate() + n);
  return out;
}

export function daysBetween(a, b) {
  return Math.round((b - a) / (1000 * 60 * 60 * 24));
}

export function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

export function addMonths(d, n) {
  return new Date(d.getFullYear(), d.getMonth() + n, 1);
}

export function fmtMonthLabel(d, showYear) {
  return d.toLocaleDateString([], { month: "short", ...(showYear ? { year: "2-digit" } : {}) });
}

export function fmtShortRange(startStr, endStr) {
  if (!startStr && !endStr) return "—";
  const s = parseYMD(startStr);
  const e = parseYMD(endStr);
  const f = (d) => d.toLocaleDateString([], { month: "short", day: "numeric" });
  if (s && e) return `${f(s)} \u2013 ${f(e)}`;
  return f(s || e);
}
